import { useLayoutEffect, useRef, useState } from "react";
import { getRoundedPolygonPath, getShapeVertices, SHAPE_CORNERS } from "@/lib/shapeGeometry";

export default function ShapeLayer({ layer, custom = {}, scale = 1 }) {
  const svgRef = useRef(null);
  const [size, setSize] = useState({ width: 100, height: 100 });

  useLayoutEffect(() => {
    const element = svgRef.current;
    if (!element) return undefined;

    const updateSize = () => {
      const width = element.clientWidth;
      const height = element.clientHeight;
      if (width > 0 && height > 0) {
        setSize((current) => current.width === width && current.height === height
          ? current
          : { width, height });
      }
    };
    updateSize();
    const observer = new ResizeObserver(updateSize);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  const value = (key, fallback) => custom[key] ?? layer[key] ?? fallback;
  const fill = value("backgroundColor", "#14b8a6");
  const fillOpacity = value("backgroundOpacity", 1);
  const stroke = value("borderColor", "#000000");
  const strokeWidth = Math.max(0, Number(value("borderWidth", 0))) * scale;
  const shapeType = value("shapeType", "square");
  const settings = { ...layer, ...custom };
  const vertices = getShapeVertices(settings, size.width, size.height);
  const allRadius = Number(value("borderRadius", 0)) * scale;
  const radii = SHAPE_CORNERS.map(({ radius }) => Number(value(radius, allRadius / scale)) * scale);

  return (
    <svg ref={svgRef} className="w-full h-full pointer-events-none overflow-visible" viewBox={`0 0 ${size.width} ${size.height}`} preserveAspectRatio="none" aria-hidden="true">
      {shapeType === "circle" ? (
        <ellipse cx={size.width / 2} cy={size.height / 2} rx={Math.max(0, size.width / 2 - strokeWidth / 2)} ry={Math.max(0, size.height / 2 - strokeWidth / 2)} fill={fill} fillOpacity={fillOpacity} stroke={stroke} strokeWidth={strokeWidth} />
      ) : (
        <path d={getRoundedPolygonPath(vertices, radii)} fill={fill} fillOpacity={fillOpacity} stroke={stroke} strokeWidth={strokeWidth} />
      )}
    </svg>
  );
}
